import React, { ComponentType } from 'react'
import { css } from 'src/ui/style/css'
import brandAssets from 'src/brand/assets'
import { Image } from 'src/ui/img/Image'
import { alternateTexts } from 'src/seo/altNames'

export const Logo: ComponentType<{ highRes?: boolean }> = ({
    highRes = false
}) => (
    <Image
        alt={alternateTexts.logo}
        src={highRes ? brandAssets.LogoHighRes : brandAssets.Logo}
        css={css`
            height: ${highRes ? 'auto' : '100%'};
            object-fit: contain;
        `}
    />
)
